import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Collection, CollectionShareLinkData, ReadonlyPermission} from "../../../collection.model";
import {CollectionService} from "../../../collection.service";
import {FormBuilder, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel, MatOption, MatSelect, MatSuffix} from "@angular/material/select";
import {MatInput} from "@angular/material/input";
import {TranslatePipe} from "@ngx-translate/core";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import moment from 'moment';
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from "@angular/material/timepicker";

@Component({
    selector: 'app-collection-share-link',
    imports: [
        MatSelect,
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatLabel,
        TranslatePipe,
        MatOption,
        MatDatepickerInput,
        MatDatepicker,
        MatDatepickerToggle,
        MatButton,
        FormsModule,
        MatSuffix,
        MatTimepicker,
        MatTimepickerInput,
        MatTimepickerToggle
    ],
    templateUrl: './collection-share-link.component.html',
    styleUrl: './collection-share-link.component.scss'
})
export class CollectionShareLinkComponent implements OnInit {

    @Input({required: true}) collection!: Collection;
    @Output() collectionChange = new EventEmitter<Collection>();
    @Output() back = new EventEmitter<void>();

    edit = false;
    error: string | null = null;

    active = true;

    // use template driven for date/timepicker https://github.com/angular/angular/issues/58522
    permission?: ReadonlyPermission
    validFrom?: Date;
    validUntil?: Date;

    constructor(
        private collectionService: CollectionService,
        private fb: FormBuilder
    ) {
    }

    ngOnInit() {
        if (!this.collection.sharedLink) {
            this.permission = 'download';
        } else {
            this.edit = true;
            this.validFrom = this.collection.sharedLink.validFrom;
            this.validUntil = this.collection.sharedLink.validUntil;
            this.permission = this.collection.sharedLink.permission;
        }
    }
    revoke() {
        let data: CollectionShareLinkData = {
            permission: this.permission!!,
            validFrom: this.validFrom ? moment(this.validFrom).format('YYYY-MM-DDTHH:mm:ssZ') : undefined,
            validUntil: this.validUntil ? moment(this.validUntil).format('YYYY-MM-DDTHH:mm:ssZ') : undefined
        }
        this.collectionService.revokeCollectionShare(this.collection.uuid).subscribe({
            next: collection => {
                this.collection = collection;
                this.collectionChange.emit(collection);
                this.back.emit();
            },
            error: (e) => {
                console.error(e);
                this.error = 'Error revoking shared link';
            }
        });

    }

    confirm() {
        let data: CollectionShareLinkData = {
            permission: this.permission!!,
            validFrom: this.validFrom ? moment(this.validFrom).format('YYYY-MM-DDTHH:mm:ssZ') : undefined,
            validUntil: this.validUntil ? moment(this.validUntil).format('YYYY-MM-DDTHH:mm:ssZ') : undefined
        }
        /*if (!this.active) {

        } else */if (this.edit) {
            this.collectionService.updateCollectionShare(this.collection.uuid, data).subscribe({
                next: collection => {
                    this.collection = collection;
                    this.collectionChange.emit(collection);
                    this.back.emit();
                },
                error: (e) => {
                    console.error(e);
                    this.error = 'Error updating shared link';
                }
            });
        } else {
            this.collectionService.shareCollection(this.collection.uuid, data).subscribe({
                next: collection => {
                    this.collection = collection;
                    this.collectionChange.emit(collection);
                    this.back.emit();
                },
                error: (e) => {
                    console.error(e);
                    this.error = 'Error creating shared link';
                }
            });
        }
    }
    close() {
        this.back.emit();
    }

}
